<template>
  <div class="teaching-score-input-merge">
    <span v-if="elective.scoreMergeLuru"
          :class="['value', computeState]">{{elective.scoreMergeLuru}}</span>
    <span v-else
          class="empty">{{emptyText}}</span>
  </div>
</template>

<script>
import scoreComputeUtils from '../../../../../../../../../util/biz/scoreComputeUtils'
export default {
  name: 'TeachingScoreInputMerge',
  props: {
    scoreRule: {
      type: Object,
      required: true
    },
    elective: {
      type: Object,
      required: true
    },
    scoreGrade: Object,
    emptyText: {
      type: String,
      default: '-'
    }
  },
  computed: {
    computeMerge () {
      return scoreComputeUtils.scoreMerge(this.scoreRule, this.elective, this.scoreGrade)
    },
    computeState () {
      let scoreMergeZh = this.elective.scoreMergeZh
      if (typeof scoreMergeZh === 'number') {
        let passScore = this.scoreRule.passScore
        if (scoreMergeZh < (typeof passScore === 'number' ? passScore : 60)) {
          return 'is-fail'
        }
      }
    }
  },
  watch: {
    computeMerge: {
      handler (val) {
        if (val) {
          this.$set(this.elective, 'scoreMergeLuru', val.mergeLuru)
          this.$set(this.elective, 'scoreMergeZh', val.mergeZh)
        } else {
          this.$set(this.elective, 'scoreMergeLuru', '')
          this.$set(this.elective, 'scoreMergeZh', null)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-merge {
    & > .value {
      color: #303133;
      font-weight: bold;
    }
    & > .empty {
      color: #909399;
    }
  }
</style>
